import {Component, EventEmitter, Input, Output, HostListener} from '@angular/core';
import {Pagination} from '../../../model/pagination';
import {NgForOf, NgIf} from '@angular/common';
import {createPaginationArray} from '../../../functions/createNumberArray';
import {IconComponent} from '../icon/icon.component';
import {Icons} from '../../../model/icon';

@Component({
  selector: 'app-pagination',
  imports: [
    NgForOf,
    NgIf,
    IconComponent
  ],
  templateUrl: './pagination.component.html',
  standalone: true,
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent {
  @Input() pagination: Pagination<any> = { page: { number: 3, totalPages: 0, size: 0, totalElements: 0 }, content: [] };
  @Output() emitPagination: EventEmitter<Pagination<any>> = new EventEmitter();

  sizes: number[] = [5, 10, 25, 50];

  isMobile: boolean = false;
  isVerySmallScreen: boolean = false;

  constructor() {
    this.checkScreenSize();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isMobile = window.innerWidth <= 576;
    this.isVerySmallScreen = window.innerWidth <= 400;
  }

  getMaxPages(): number {
    if (this.isVerySmallScreen) return 3;
    if (this.isMobile) return 5;
    return 8;
  }

  selectPage(page: string) {
    const pageNumber = Number(page);
    if (!isNaN(pageNumber)) {
      this.pagination.page.number = pageNumber - 1;
      this.emitPagination.emit(this.pagination);
    }
  }

  selectSize(size: number){
    this.pagination.page.size = size;
    this.emitPagination.emit(this.pagination);
  }

  getPaginationArray(): (number | string)[] {
    return createPaginationArray(
      0,
      this.pagination.page.totalPages,
      this.pagination.page.number,
      this.getMaxPages()
    );
  }

  safeSelectPage(page: string | number): void {
    if (page !== '...') {
      this.selectPage(page.toString());
    }
  }

  protected readonly createPaginationArray = createPaginationArray;
  protected readonly Number = Number;
  protected readonly Icons = Icons;
}
